<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Woordenslang" [steps]="snakes().length" [progress]="snakeIndex()" />

  <rid-mechanic-content>
    <!-- title -->
    <rid-mechanic-title [title]="'Sleep een woord om een samengesteld woord te maken'" />

    <!-- assignment -->
    @if (showAssignment()) {
      <div class="absolute grid w-full justify-items-center gap-24" animate.leave="anim-fade-out">
        <!-- words -->
        <div class="flex gap-4">
          @for (option of assignment().options; track $index) {
            <div class="grid">
              <rid-spacer class="stack-cell">
                <rid-klank-card
                  class="block w-3xs"
                  [klank]="option.word"
                  animate.enter="anim-pop-in"
                  [style.animation-delay.ms]="500 + $index * 100"
                />
              </rid-spacer>

              @if (option.available) {
                <rid-draggable class="stack-cell" (moved)="onDragMove($event[0], $event[1])" (released)="onDragRelease($event, $index)">
                  <rid-klank-card
                    class="block w-3xs"
                    [klank]="option.word"
                    animate.enter="anim-pop-in"
                    [style.animation-delay.ms]="500 + $index * 100"
                  />
                </rid-draggable>
              }
            </div>
          }
        </div>

        <div class="justify-self-stretch" animate.enter="wait-750 anim-fade-from-right">
          <div class="flex justify-center">
            <div class="flex gap-4 transition-transform duration-500 ease-in-out" [style.transform]="snakeTransform()">
              @for (word of assignment().snake; track $index) {
                <div class="w-3xs">
                  <rid-klank-card
                    class="block transition-all duration-500"
                    [class.opacity-50]="!snakeComplete() && $index < assignment().snake.length - 1"
                    [class.scale-75]="!snakeComplete() && $index < assignment().snake.length - 1"
                    [klank]="word"
                  />
                </div>
              }
              @if (!snakeComplete()) {
                <div class="font-family-din content-center text-4xl text-white select-none">+</div>
                <rid-drop-zone #dropZone class="block w-3xs rounded-sm border-4 border-dashed border-white p-4 text-4xl select-none" />
              }
            </div>
          </div>
        </div>
      </div>
    }
    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
